// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__+80R4","imageWrapper":"Intro_imageWrapper__x2AZs","introImage":"Intro_introImage__s1FHF","headingAndP":"Intro_headingAndP__DRpud"};